import { actions } from 'forms/rrf';
import { toast } from 'react-toastify';
import FileDownload from 'react-file-download';
import { history } from '../store';
import irelandApi from '../irelandApi';
import ToastMessage from '../components/common/toast-message';
import { destandard, objectToFormData, removeNullFieldsFromJson } from '../utils/commonFunctions';

const prepareStockItPayload = (payLoad) => {
  const stockItData = removeNullFieldsFromJson(payLoad);
  stockItData.group_ids = [];

  if (stockItData.abm_codes) {
    stockItData.stocks_abms_attributes = stockItData.abm_codes.map(curr => ({ abm_code: curr.value }));
  }

  if (stockItData.wse_bands) {
    stockItData.stocks_wse_bands_attributes = stockItData.wse_bands.map(curr => ({ wse_band: curr.value }));
  }

  if (stockItData.postcodes) {
    stockItData.stocks_postcodes_attributes = stockItData.postcodes.map(curr => ({ postcode: curr.value }));
  }

  if (stockItData.sub_zones) {
    stockItData.stocks_sub_zones_attributes = stockItData.sub_zones.map(curr => ({ horizon_sub_zone_id: curr.value }));
  }

  if (stockItData.zones) {
    stockItData.stocks_zones_attributes = stockItData.zones.map(curr => ({ horizon_zone_id: curr.value }));
  }
  if (stockItData.product_ids) {
    stockItData.product_ids = stockItData.product_ids.map(curr => curr.value);
  }
  if (stockItData.groups) {
    stockItData.group_ids = stockItData.groups.map(curr => curr.value);
    delete stockItData.groups;
  }

  if (stockItData.levels) {
    stockItData.stock_objectives_levels_attributes = Object.keys(stockItData.levels).map(key => ({
      ...stockItData.levels[key], level_id: key
    }));
    delete stockItData.levels;
  }

  return objectToFormData(stockItData, 'stock_objective');
};

export const getStockIt = id => (dispatch) => {
  dispatch({type: 'GET_STOCK_IT_PENDING', payload: []});
  return irelandApi.get(`/api/admin/stock_it/${id}`)
    .then((response) => {
      const data = destandard({...response.data.data.attributes});
      dispatch(actions.load('deep.stock_it', data));
      dispatch({
        type: 'GET_STOCK_IT_FULFILLED',
        payload: data
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_STOCK_IT_REJECTED',
        payload: error.response
      });
      return Promise.reject(error.response.data.errors);
    });
};

export const getStockItMeta = () => (dispatch) => {
  dispatch({type: 'GET_STOCK_IT_META_PENDING', payload: []});
  return irelandApi.get('/api/admin/stock_it/meta')
    .then((response) => {
      dispatch({
        type: 'GET_STOCK_IT_META_FULFILLED',
        payload: response.data.meta
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_STOCK_IT_META_REJECTED',
        payload: error.response
      });
      return Promise.reject(error.response.data.errors);
    });
};

export const getStockItObjectives = name => (dispatch) => {
  dispatch({type: 'GET_STOCK_IT_OBJECTIVES_PENDING', payload: []});
  // Send q as a JSON STRING: the backend StockObjective.filter_by does JSON.parse(params[:q]),
  // but axios 1.x serializes a nested object as q[name]=... (brackets), which Rails turns into a
  // Hash → JSON.parse fails → rescue {} → no filter (returns everything). IGN-2368. (Coexists with
  // the systemic legacyParamsSerializer when #4343 lands: an already-stringified q is a primitive
  // it passes through unchanged.)
  const q = JSON.stringify({ name });
  return irelandApi.get('/api/admin/stock_it', {params: {q}})
    .then((response) => {
      dispatch({
        type: 'GET_STOCK_IT_OBJECTIVES_FULFILLED',
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_STOCK_IT_OBJECTIVES_REJECTED',
        payload: error.data
      });
      return Promise.reject(error.response.data);
    });
};

export const createStockIt = (payLoad, dispatch) => {
  const formData = prepareStockItPayload(payLoad);

  const config = {
    headers: {'content-type': 'multipart/form-data'}
  };

  dispatch({type: 'ADD_STOCK_IT_PENDING'});
  return irelandApi.post('/api/admin/stock_it', formData, config)
    .then((response) => {
      dispatch({
        type: 'ADD_STOCK_IT_FULFILLED',
        payload: response.data
      });
      toast.success(<ToastMessage iconStyle='success' message='Stock it objective created successfully'/>);
      history.push('/admin/objectives/stock-it');
    })
    .catch((error) => {
      dispatch({
        type: 'ADD_STOCK_IT_REJECTED',
        payload: error.response.data.errors
      });
      toast.error(<ToastMessage iconStyle='error' message='An error occurred during create stock it objective'/>);
      return Promise.reject(error.response.data.errors);
    });
};

export const updateStockIt = (id, payLoad, dispatch) => {
  const formData = prepareStockItPayload(payLoad);

  const config = {
    headers: {'content-type': 'multipart/form-data'}
  };

  dispatch({type: 'UPDATE_STOCK_IT_PENDING'});
  return irelandApi.patch(`/api/admin/stock_it/${id}`, formData, config)
    .then((response) => {
      dispatch({
        type: 'UPDATE_STOCK_IT_FULFILLED',
        payload: response.data
      });
      toast.success(<ToastMessage iconStyle='success' message='Stock it objective updated successfully'/>);
      history.push('/admin/objectives/stock-it');
    })
    .catch((error) => {
      dispatch({
        type: 'UPDATE_STOCK_IT_REJECTED',
        payload: error.response.data.errors
      });
      toast.error(<ToastMessage iconStyle='error' message='An error occurred during update stock it objective'/>);
      return Promise.reject(error.response.data.errors);
    });
};

export const downloadStockIt = id => () => irelandApi.get(`/api/admin/stock_it/${id}/download`)
  .then((response) => {
    let filename = 'stock-it.csv';
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(response.headers['content-disposition']);
    if (matches && matches[1]) {
      filename = matches[1].replace(/['"]/g, '');
    }
    FileDownload(response.data, filename);
  })
  .catch(() => {
  });
